/* eslint-disable @typescript-eslint/no-explicit-any */

import { isObject } from '@loadsmart/utils-object'
import { isFunction } from '@loadsmart/utils-function'

interface Thenable {
  then(): any
}

// TODO: add this helper to @loadsmart/utils
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isThenable(object: any): object is Thenable {
  return isObject(object) && isFunction((object as Thenable)['then'])
}
